import { ApolloClient, gql, useQuery } from "@apollo/client";
import { ISidebarQuery, ISidebarQueryVariables } from "../../graphql/gpl-graphQLTypes.gen";

export const sidebarQuery = gql`
  query Sidebar {
    industries {
      slug
      label
    }
    topics(filters: { importance: PRIMARY }) {
      slug
      label
    }
  }
`;

export function useSidebarQuery() {
  return useQuery<ISidebarQuery, ISidebarQueryVariables>(sidebarQuery);
}

export function sidebarDataQueries(apolloClient: ApolloClient<any>) {
  return apolloClient.query<ISidebarQuery, ISidebarQueryVariables>({ query: sidebarQuery });
}
